<template>
  <PaymentForm>
      <FormSection title="Payment Details">
        <FormRow inline>
          <FormCol field="amount" />
        </FormRow>
        <FormRow inline>
          <FormCol field="firstName" />
          <FormCol field="lastName" />
        </FormRow>                
        <FormRow inline>
          <FormCol field="email" />
          <FormCol field="phone" />
        </FormRow>    
        <FormRow inline>
                      <Consent privacy="https://www.ou.org/privacy-policy/"/>
                  </FormRow>                      
      </FormSection>
      <FormSection>
        <FormRow>
          <PaymentOptions addSplit addMonthly/>
      </FormRow>
      <FormRow>
        <Receipt/>
      </FormRow>
      </FormSection>
      <FormSection title="Payment Information">
      <FormRow inline>
        <FormCol field="card"  :showLabel="false"/>
      </FormRow>

      </FormSection>
      
      <FormSection title="Billing Information" >
          <DonorAddress />
      </FormSection>
      <FormRow>
          <PaymentButton/>
      </FormRow>
  </PaymentForm>

</template>